export default __webpack_public_path__ + "static/media/tank.241cd015.svg";